module.exports = __webpack_public_path__ + "static/media/medium_sm.173f41dcfa02f229c5b89c583884fd33.svg";